import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=21b09e44&"
import script from "./Tinymce.vue?vue&type=script&lang=ts&"
export * from "./Tinymce.vue?vue&type=script&lang=ts&"
import style0 from "./Tinymce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports